module.exports = new __parcel__URL__("plasma_cannon_level_1.6fc2ad00.png").toString();